import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPrPatientWarnings } from '../reduxStore/actions/commonAction';
import { checkPatientWarnings } from '../api/patients';

export function usePatientWarningCheck(checkWarning) {
  const dispatch = useDispatch();
  const patientId = useSelector((state) => state.commonReducers.prPatientId);

  useEffect(() => {
    const checkWarnings = async () => {
      if (checkWarning) {
        try {
          const res = await checkPatientWarnings({ patientId });
          dispatch(setPrPatientWarnings(res.data.warningData));
        } catch (error) {}
      }
    };
    checkWarnings();
  }, [checkWarning, patientId, dispatch]);
}
